module.exports = __webpack_public_path__ + "media/images/icons/image-4c375aceb8a417d5b50efb57b25d52ea.svg";